import { useOpen, useBlobUrl } from "../../../../../../../libs/hooks";
import { useWorkflowStore } from "../../../../../store";
import { Grid } from "@mui/material";
import { OnlyPhoto } from "../../../../../../../libs/shared";


export const Documentos = () => {
  return (
    <Grid
      container
      justifyContent="flex-start"
      alignContent="flex-start"
      alignItems="flex-start"
      spacing={0}
      sx={{ bgcolor: "white", pt: 1 }}
    >
      <DocumentEir />
      <DocumentCiC />
    </Grid>
  );
};


const DocumentEir = () => {
  const {
    open: openEir,
    handleClose: handleCloseEir,
    handleOpen: handleOpenEir,
  } = useOpen();

  const eirPhoto = useWorkflowStore((state) => state.eirPhoto);

  const setEirPhoto = useWorkflowStore((state) => state.setEirPhoto);

  const fotoUrl = useBlobUrl(eirPhoto);

  return (
    <Grid
      item
      xs={12}
      sx={{
        mb: 2,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        pl: 1.6,
      }}
    >
      <OnlyPhoto
        foto={fotoUrl}
        handleClose={handleCloseEir}
        handleOpen={handleOpenEir}
        label="EIR"
        open={openEir}
        setFoto={setEirPhoto}
        width={260}
        fontSize={12}
      />
    </Grid>
  );
};

const DocumentCiC = () => {
  const {
    open: openCiConductor,
    handleClose: handleCloseCiConductor,
    handleOpen: handleOpenCiConductor,
  } = useOpen();

  const ciConductorPhoto = useWorkflowStore((state) => state.ciConductorPhoto);

  const setCiConductorPhoto = useWorkflowStore(
    (state) => state.setCiConductorPhoto
  );

  const fotoUrl = useBlobUrl(ciConductorPhoto);


  return (
    <Grid
      item
      xs={12}
      sx={{
        mb: 2,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        pl: 1.6,
      }}
    >
      <OnlyPhoto
        foto={fotoUrl}
        handleClose={handleCloseCiConductor}
        handleOpen={handleOpenCiConductor}
        label="IDENTIFICACIÓN CONDUCTOR"
        open={openCiConductor}
        setFoto={setCiConductorPhoto}
        width={260}
        fontSize={12}
      />
    </Grid>
  );
};
